export * from './icons';
export { default as Icon } from './Icon';
export { default as IconText } from './IconText';
export { default as IconAndNode } from './IconAndNode';
export { default as GreenCheck } from './GreenCheck';
import Icon from './Icon';

export default Icon;
